import { rand, randFloat, randNumber, randPastDate, randRecentDate, randWord } from '@ngneat/falso';

import { MockBillingParty, MockHawb, MockReference, MockStatus } from '@library/common/models/mock';
import { QuotationModes, QuotationTypes, ModeMilestone } from '@library/common/models';
import { titleCase } from '@library/common';

import { QuotationSnapshot } from '@library/modules/quotation';

export class MockQuotationSnapshot extends QuotationSnapshot {
    constructor() {
        super();

        this.cost = randFloat({ min: 0, max: 10000 }).toFixed( 6 );

        this.quoteType = rand([ ...QuotationTypes ]);
        this.mode = rand([ ...QuotationModes ]);
        this.fwq = MockHawb();
        this.references = Array.from({ length: randNumber({ max: 20 }) }, _ => new MockReference() );
        this.serviceLevel = titleCase( randWord({ length: 2 }).join( ' ' )) as string;
        this.statuses = Array.from({ length: randNumber({ min: 1, max: 5 }) }, _ => new MockStatus() );

        this.milestones = new ModeMilestone();
        Object.keys( this.milestones ).slice( 0, randNumber({
            min: 1,
            max: Object.keys( this.milestones ).length,
        })).map( key => {
            if ( key === 'accepted' || key === 'rejected' ) {
                if ( this.milestones['accepted'] === '' && this.milestones['rejected'] === '' ) {
                    this.milestones[rand(['accepted', 'rejected'])] = randRecentDate({ days: 20 });
                }
            } else {
                this.milestones[key] = randRecentDate({ days: 20 });
            }
        });

        this.shipper = new MockBillingParty();
        this.consignee = new MockBillingParty();
        this.bill_to = new MockBillingParty();

        const pastDate = randPastDate();

        this.createdDate = pastDate.getUTCFullYear() + '-' + (pastDate.getUTCMonth() + 1).toString().padStart(2, '0') + '-' + pastDate.getUTCDate().toString().padStart(2, '0'); 
        this.createdTime = pastDate.getUTCHours().toString().padStart(2, '0') + ':' + pastDate.getUTCMinutes().toString().padStart(2, '0') + ':' + pastDate.getUTCSeconds().toString().padStart(2, '0');
    }
}